import script from "./ImageEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageEdit.vue?vue&type=script&lang=ts&setup=true"

import "./ImageEdit.vue?vue&type=style&index=0&id=7244cff4&scoped=true&lang=less"

import exportComponent from "/Users/Carl/Develop/go/src/github.com/Soesah/soesahgaming.lostmarbles.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7244cff4"]])

export default __exports__